const CURRENCY_SYMBOL = { EUR: "€", USD: "$", GBP: "£" };

export const PublicQrPrice = ({ block, value, currency, label }) => {
  if (block?.is_enabled === false || value == null || String(value).trim() === "" || !Number.isFinite(Number(value))) return null;

  const code = currency || "EUR";
  const price = `${CURRENCY_SYMBOL[code] || code} ${Number(value).toFixed(2).replace(".", ",")}`;
  return (
    <div className="pp-block" data-testid="block-price">
      <div className="pp-meta-row">
        <span data-testid="block-price-text">{label} <strong data-testid="block-price-value">{price}</strong></span>
      </div>
    </div>
  );
};